<app-website-header></app-website-header>
<div class="signup-container">
  <div class="d-flex flex-column align-items-center">
  <div class="col-md-3 col-12 top-banner" >
    <div class="col-12 mx-auto top d-none d-lg-block">
      <p class="exhibit mr-3"><span>Exhibit</span>&nbsp;With Us</p>
    </div>
    
    
    <div class="exhibit d-lg-none position-class">
      <span class="exhibit-with-us"><span class="exhibit-span">Exhibit</span>&nbsp;
      <span class="with-us"> With Us</span></span>
    </div>
  </div>
  <div class="col-4 mx-auto subtext-t " style="padding-top: 2%; position: relative; z-index: 999;">
    <div class="col-12 mx-auto top d-none d-lg-block">
        <p class="subtext mr-3" style="text-align: justify;">
            Looking for an opportunity to showcase and promote your products and services digitally
        </p>
    </div>
    
    <div class="subtext col-3 d-lg-none">
        <p class="subtext " >
            Looking for an opportunity to showcase <br> 
               and promote your products and <br>
                      services digitally
        </p>
    </div>
</div>
</div>
  <div class="col-10 mx-auto signup-overall-card-container" >
    <div
      class="d-flex justify-content-center align-items-center  signup-cards-container"
    >
      <div
        class="col-md-4 d-flex flex-column align-items-center bg-white p-4 br-2 green-border signup-card gap-2"
      >
        <img
          class="icon"
          src="assets/images/account_type/factory.svg"
          alt=""
          
        />
        <h1>Are you a Manufacturer</h1>
        <p class="text-center" style="max-width: 314px;">
          Showcase your Products, Connect with<br/>
          new Distributors and Receive<br/>
          International leads
        </p>
        <a
          routerLink="/oem/signup"
          class="btn btn-primary d-flex align-items-center"
        >
          Sign up
          <img
            src="assets/images/account_type/arrow right top.svg"
            alt=""
            class="ml-2"
            height="18px"
            width="20px"
          />
        </a>
      </div>
      <div
        class="col-md-4 d-flex flex-column align-items-center bg-white p-4 br-2 signup-card gap-2"
      >
        <img
          class="icon"
          src="assets/images/account_type/trolley.svg"
          alt=""
        />
        <h1> Are you a Distributor</h1>
        <p class="text-center" style="max-width: 314px;">
          Connect with Original Equipment<br/>
          Manufacturers (OEMs) to start<br/>
          Showcasing and Distributing their products
        </p>
        <a
          routerLink="/distributor/signup"
          class="btn btn-primary d-flex align-items-center"
        >
          Sign up
          <img
            src="assets/images/account_type/arrow right top.svg"
            alt=""
            class="ml-2"
            height="18px"
            width="20px"
          />
        </a>
      </div>
    </div>
  </div>
</div>


<app-website-footer></app-website-footer>